<template>
  <v-container class="pt-0 mt-0">
    <v-row class="mt-0 pt-0 mb-0 pb-0">
      <v-col cols="12" class="text-right">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div style="width: 115px; display: inline-block" v-bind="attrs" v-on="on">
              <FiscalYearField
                dense
                hide-details
                label="Fiscal Year"
                hint="Fiscal Year"
                persistent-hint
                solo-inverted
                dark
                :numberOfFutureYears="0"
                :numberOfPastYears="2"
                :client="selectedClient"
                @inputObj="selectedFiscalYear = $event"
                use-store
              >
              </FiscalYearField>
            </div>
          </template>
          Fiscal Year
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-alert border="top" colored-border color="primary" elevation="2">
          <ContentView contentKey="DISTRICT_MANAGER_WELCOME" />
        </v-alert>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <MyDealersWidget />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="6">
        <DealerIncentivesWidget />
      </v-col>

      <v-col cols="6">
        <DealerSalespersonPendingWidget />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-alert border="top" colored-border color="primary" elevation="2">
          <ContentView contentKey="DISTRICT_MANAGER_CONTACTS" />
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import MyDealersWidget from "./MyDealersWidget.vue";
import DealerIncentivesWidget from "./DealerIncentivesWidget.vue";
import DealerSalespersonPendingWidget from "./DealerSalespersonPendingWidget.vue";
import ContentView from "@/gapp-components/components/common/content/ContentView.vue";
import FiscalYearField from "@/gapp-components/components/fields/FiscalYearField.vue";

export default {
  name: "DistrictManagerDashboard",
  data() {
    return {
      loading: false,
      items: []
    };
  },
  metaInfo: {
    title: "District Manager Dashboard"
  },
  components: {
    MyDealersWidget,
    DealerSalespersonPendingWidget,
    ContentView,
    DealerIncentivesWidget,
    FiscalYearField
  },

  computed: {
    ...mapGetters(["selectedClient"])
  },

  mounted() {
    this.$store.dispatch("setBreadcrumb", []);
    this.$content.refreshContent();
  }
};
</script>
